export default __webpack_public_path__ + "static/media/devguide01.52974ee1.md";